var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25V10.625",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8477 2.5H7.15228C7.07021 2.5 6.98893 2.51617 6.9131 2.54758C6.83728 2.57898 6.76838 2.62502 6.71034 2.68306L2.68306 6.71034C2.62502 6.76838 2.57898 6.83728 2.54758 6.9131C2.51617 6.98893 2.5 7.07021 2.5 7.15228V12.8477C2.5 12.9298 2.51617 13.0111 2.54758 13.0869C2.57898 13.1627 2.62502 13.2316 2.68306 13.2897L6.71034 17.3169C6.76838 17.375 6.83728 17.421 6.9131 17.4524C6.98893 17.4838 7.07021 17.5 7.15228 17.5H12.8477C12.9298 17.5 13.0111 17.4838 13.0869 17.4524C13.1627 17.421 13.2316 17.375 13.2897 17.3169L17.3169 13.2897C17.375 13.2316 17.421 13.1627 17.4524 13.0869C17.4838 13.0111 17.5 12.9298 17.5 12.8477V7.15228C17.5 7.07021 17.4838 6.98893 17.4524 6.9131C17.421 6.83728 17.375 6.76838 17.3169 6.71034L13.2897 2.68306C13.2316 2.62502 13.1627 2.57898 13.0869 2.54758C13.0111 2.51617 12.9298 2.5 12.8477 2.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.375C10.5178 14.375 10.9375 13.9553 10.9375 13.4375C10.9375 12.9197 10.5178 12.5 10 12.5C9.48223 12.5 9.0625 12.9197 9.0625 13.4375C9.0625 13.9553 9.48223 14.375 10 14.375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOctagon);
export default __webpack_public_path__ + "static/media/warning-octagon.58f2e95c8ef1267a9d607928e8d6468d.svg";
export { ForwardRef as ReactComponent };